import React from "react"

import FieldCrmContactType_Value from "../value/value"
import FieldCrmContactType_ValueEmpty from "../value/value-empty"
import {FieldViewProps} from "../../../../../render/view"

// the read only contact type - the same box the inline editable draws, without its hover and arrow
export default function FieldCrmContactType_View(props: FieldViewProps) {

    // _getOption() answers false while the contact has no type
    const option = props.field._getOption(props.model[props.field.fieldId])

    if (!option) {
        return (
            <FieldCrmContactType_ValueEmpty
                field           = {props.field}
                className       = {props.className}
                configOptions   = {props.configOptions}
                disabled        = {true}
            />
        )
    }

    return (
        <FieldCrmContactType_Value
            option          = {option}
            className       = {props.className}
            labelClassName  = {props.configOptions?.labelClassName}
            disabled        = {true}
        />
    )
}
